import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Intercept global fetch to filter out Coffee Beans products from the LIVE API responses
const originalFetch = window.fetch;
window.fetch = async function (...args) {
  const response = await originalFetch(...args);
  if (response.ok && typeof args[0] === 'string' && 
      (args[0].includes('getallspecialproduts') || 
       args[0].includes('getsimilarproducts') || 
       args[0].includes('getproductbyiduserside') ||
       args[0].includes('getproductbysubcategoryiduserside'))) {
    
    const clone = response.clone();
    try {
      const data = await clone.json();
      
      // Create clean headers mapping to avoid length or encoding mismatches
      const cleanHeaders = new Headers(response.headers);
      cleanHeaders.delete("content-length");
      cleanHeaders.delete("content-encoding");

      if (Array.isArray(data)) {
        const filtered = data.filter(item => !item?.product_name?.toLowerCase().includes('coffee bean'));
        return new Response(JSON.stringify(filtered), {
          status: response.status,
          statusText: response.statusText,
          headers: cleanHeaders
        });
      } else if (data && typeof data === 'object') {
        let modified = false;
        for (const key in data) {
          if (Array.isArray(data[key])) {
            data[key] = data[key].filter(item => !item?.product_name?.toLowerCase().includes('coffee bean'));
            modified = true;
          }
        }
        
        if (data.product_name && data.product_name.toLowerCase().includes('coffee bean')) {
          return new Response(JSON.stringify({}), { status: 404 });
        }
        
        if (modified) {
          return new Response(JSON.stringify(data), {
            status: response.status,
            statusText: response.statusText,
            headers: cleanHeaders
          });
        }
      }
    } catch (e) {
      // Return original response on parsing errors
    }
  }
  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
